/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId, setSort } from "../../../../redux/features/shared/sharedSlice";
import { ClassesModal } from "./ClassesModal";
import './style.scss';
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { getServices } from "../../../../redux/features/service/_serviceAction";
import { servicesColumns } from "../common/common-list/table/columns/_serviceColumns";
import { getClasses } from "../../../../redux/features/classes/_classesAction";
import { companyColumns } from "../common/common-list/table/columns/_companyColumns";
import { classColumns } from "../common/common-list/table/columns/_classColumns";

const ClassesList = () => {
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const dispatch: any = useDispatch();
  const data: any = useSelector((state: any) => state.classesList?.data)||[];
  const totalRecord  = useSelector((state: any) => state.classesList?.totalRecord);

  useEffect(() => {
    dispatch(setId('Classes'))
    dispatch(setSort('date'))
    dispatch(getClasses({ page: 1, limit: 10, sortOrder: sharedActions.sort }));
  }, [dispatch, sharedActions.sort]);

  const handleClick = (page: number) => {
    dispatch(getClasses({ page: page, limit: 10, sortOrder: sharedActions.sort }));
  };


  return (
    <>
      <KTCard>
        <UserListHeader />
        <CommonTable data={data} columns={classColumns} />
        {sharedActions.classesModal && <ClassesModal />}
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { ClassesList };
